import Vue from 'vue'
import Router from 'vue-router'
import qs from 'qs'
import MEISHIBANK2 from 'static/config'

// システム画面
import routesSystem from './routes.system'
// 一般画面
import routesGeneral from './routes.general'
// メンテナンス画面
import routesMaintenance from './routes.maintenance'
// 個人設定画面
import routesPset from './routes.pset'
// 機能管理画面
import routesManage from './routes.manage'
// 機能管理画面
import routesSysset from './routes.sysset'
// desknet's NEO 連携画面
import routesNeo from './routes.neo'

Vue.use(Router)

// routes 設定
let routes = routesSystem
  .concat(routesGeneral)
  .concat(routesMaintenance)
  .concat(routesPset)
  .concat(routesManage)
  .concat(routesSysset)

// NEO 連携フラグがONならrouteを追加
if (MEISHIBANK2.flags.appsIntegrate) {
  routes = routes.concat(routesNeo)
}

const router = new Router({
  scrollBehavior (to, from, savedPosition) {
    // 画面遷移時はスクロールTOPに戻る
    return { x: 0, y: 0 }
  },
  routes: routes
})

router.beforeEach(function (to, from, next) {
  const vm = router.app

  // 認証不要画面以外でtokenがない場合はログイン画面へ。
  if (!vm.$store.getState('token') && to.meta.needAuth !== false) {
    router.push({
      name: 'login',
      query: {
        next: qs.stringify({
          name: to.name,
          params: to.params,
          query: to.query
        })
      }
    })
    return
  }

  // TODO fujita
  // リクエストキャンセル
  // Vue.ApiAdapter.httpCancel()
  // // リクエストトークン再設定
  // Vue.util.httpCreate()

  // 初期化フラグがある場合は
  if (to.params.init) {
    // sessionStorageを初期化する
    vm.resetSession()
    // 一覧検索条件を初期化する
    vm.$store.commit('initListConds')
  }

  // 初期化フラグがある、または、機能をまたいだ移動の場合は再読み込み
  // console.log('beforeEach')
  if (to.params.init || (from.matched.length !== 0 && to.matched[0] !== from.matched[0])) {
    // // App描画待ち
    // vm.$nextTick(function () {
    const vmApp = vm.$children[0]
    vmApp.reloader = false
    vm.$nextTick(function () {
      vmApp.initPage()
      vmApp.chkAdmin()
      vmApp.reloader = true
    })
    // })
  }
  next()
})

// URLが変更されなくても再読み込みするために、router.pushを改造する
router.push = (function (push) {
  return function (location, onComplete, onAbort) {
    const params = location.params || {}
    if (params.init && router.history.current.name === location.name) {
      location.query = location.query || {}
      // queryを変更すると、router.beforeEachが走る
      location.query._ = Math.ceil(Math.random() * 10000)
    }
    push.call(router, location, onComplete, onAbort)
  }
}(router.push))

export default router



// WEBPACK FOOTER //
// ./src/router/index.js